import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../../utils/app-settings';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImageComponent implements OnInit {

  @Input() image_key: string;
  @Input() on_error: string;
  @Input() force_reload: boolean = false;
  @Input() person_image_type: number;
  @Output() errorOccured = new EventEmitter();
  @Input() image_url: string;

  ngOnInit() {
    if (!this.image_url) {
      let image_url = AppSettings.apiUrl
        + "image/"
        + this.image_key
        + (this.person_image_type ? ("?person_image_type=" + this.person_image_type) : "");
      
      this.image_url = image_url;
    } else { 
      // Image URL already set
    }
    if (this.force_reload) {
      let force_qs = `v=${+(new Date())}`
      if (this.image_url.includes('?')) {
        this.image_url = this.image_url + "&" + force_qs;
      } else {
        this.image_url = this.image_url + "?" + force_qs;
      }
    }
  }


  setDefaultImageUrl(event) {
    this.errorOccured.emit();
    if (this.on_error) {
      event.target.src = this.on_error;
    }
  }
}
